window.Shopify = window.Shopify || {};

Shopify.formatMoney = function (cents, format = "{{amount}}") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }

  function getCurrencySymbol() {
    const currencySymbols = {
      USD: "$", // Dollar
      EUR: "€", // Euro
      GBP: "£", // Pound Sterling
      RUB: "₽", // Russian Ruble
      CAD: "CA$", // Canadian Dollar
      AUD: "AU$", // Australian Dollar
      JPY: "¥", // Japanese Yen
      CNY: "¥", // Chinese Yuan
      INR: "₹", // Indian Rupee
    };

    if (Shopify.currency && Shopify.currency.active) {
      return currencySymbols[Shopify.currency.active] || Shopify.currency.active;
    }
    return "$";
  }

  switch (format.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  const currencySymbol = getCurrencySymbol();
  return `${currencySymbol}${value}`;
};
class CartUpsell extends HTMLElement {
  constructor() {
    super(),
      (this.config = {
        upsellCount: 8,
        recommendationStrategy: "related",
        sectionTitle: "You Might Also Like",
      }),
      (this.state = { isLoading: !0, currentProducts: [], newProducts: [] });
  }
  connectedCallback() {
    this.initializeConfiguration(), this.render(), this.initUpsells();
  }
  initializeConfiguration() {
    (this.config.upsellCount = parseInt(
      this.getAttribute("data-product-count") || this.config.upsellCount
    )),
      (this.config.sectionTitle =
        this.getAttribute("data-section-title") || this.config.sectionTitle),
      (this.config.recommendationStrategy =
        this.getAttribute("data-recommendation-strategy") ||
        this.config.recommendationStrategy);
  }
  render() {
    this.innerHTML = `
      <div class="cart-upsell-container">
        <h2 class="cart-upsell-title">${this.config.sectionTitle}</h2>
        ${this.renderLoadingOverlay()}
        <div class="swiper cart-upsell-slider" aria-busy="true">
          <div class="swiper-wrapper">
         
          </div>
        </div>
      </div>
    `;
  }
  renderLoadingOverlay() {
    return `
      <div class="upsell-loading-overlay">
        <div class="upsell-loading-spinner"></div>
      </div>
    `;
  }
  async initUpsells() {
    try {
      const recommendedProducts = await this.fetchRecommendedProducts();
      if (!recommendedProducts || recommendedProducts.length === 0) {
        this.style.display = "none";
        return;
      }
      (this.state.newProducts = recommendedProducts),
        (this.state.isLoading = !1),
        this.updateUpsellProducts();
    } catch (error) {
      console.error("Upsell initialization failed:", error),
        (this.style.display = "none");
    }
  }
  async fetchRecommendedProducts() {
    const cartItems = await this.getCartItems();
    if (!cartItems || cartItems.length === 0) return [];
    const productId = cartItems[0].product_id;
    try {
      const response = await fetch(
        `/recommendations/products.json?product_id=${productId}&limit=${this.config.upsellCount}&intent=${this.config.recommendationStrategy}`
      );
      if (!response.ok) throw new Error("Failed to fetch recommended products");
      const { products } = await response.json();
      return products;
    } catch (error) {
      return console.error("Error fetching recommendations:", error), [];
    }
  }
  updateUpsellProducts() {
    const wrapper = this.querySelector(".swiper-wrapper");
    (wrapper.innerHTML = ""),
      this.state.currentProducts.length &&
        this.state.currentProducts.forEach((product) => {
          wrapper.appendChild(this.createProductSlide(product));
        }),
      this.state.newProducts.forEach((product) => {
        wrapper.appendChild(this.createProductSlide(product));
      }),
      this.querySelector(".upsell-loading-overlay").classList.add("hidden"),
      (this.state.currentProducts = [
        ...this.state.currentProducts,
        ...this.state.newProducts,
      ]),
      (this.state.newProducts = []),
      this.addCartEventListeners(),
      this.reinitializeSwiper();
  }
  createProductSlide(product) {
    const slide = document.createElement("div");
    return (
      slide.classList.add("swiper-slide", "upsell-product"),
      (slide.dataset.productId = product.id),
      (slide.innerHTML = `
       <div class="upsell-product__media">
        <img src="${product.featured_image}" alt="${
        product.title
      }" width="150" height="150" loading="lazy">
      </div>
      <div class="custom-upsell-details">
      <a href="${product.url}" class="upsell-product__title">${
        product.title
      }</a>
      <div class="upsell-product__row">
        <p class="upsell-product__price">${Shopify.formatMoney(
          product.price
        )}</p>
        <product-form>
          <form
                  method="post"
                  action="/cart/add"
                  id="product-form-template--19051402297590__main"
                  accept-charset="UTF-8"
                  class="form"
                  enctype="multipart/form-data"
                  ovalidate="novalidate" data-type="add-to-cart-form">
            <input type="hidden" name="id" value="${
              product.variants[0].id
            }" class="product-variant-id">
            <button
                    class="add-to-cart-btn button--link button upsell-product__atc"
                    aria-haspopup="dialog"
                    type="submit"
                    data-variant-id="${product.variants[0].id}"
            >
              <span>Add</span>
              <div class="loading__spinner hidden">
  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
  </svg>
</div>
            </button>
          </form>
        </product-form>
      </div>
      </div>
    `),
      slide
    );
  }
  reinitializeSwiper() {
    this.swiper && this.swiper.destroy(),
      (this.swiper = new Swiper(this.querySelector(".swiper"), {
        slidesPerView: 1.2,
        spaceBetween: 15,
        grabCursor: !0,
        mousewheel: false,
      }));
  }
  addCartEventListeners() {
    this.querySelectorAll(".add-to-cart-btn").forEach((button) => {
      button.addEventListener("click", this.addToCart.bind(this));
    });
  }
  async addToCart(event) {
    const variantId = event.target.dataset.variantId;
    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      }),
        document.dispatchEvent(new CustomEvent("cart:updated"));
    } catch (error) {
      console.error("Add to cart failed:", error);
    }
  }
  async getCartItems() {
    return (await (await fetch("/cart.js")).json()).items;
  }
}
customElements.define("cart-upsell", CartUpsell);

class ProductUpsell extends HTMLElement {
  constructor() {
    super(),
      (this.config = {
        upsellCount: 8,
        recommendationStrategy: "related",
        sectionTitle: "You Might Also Like",
      }),
      (this.state = { isLoading: !0, currentProducts: [], newProducts: [] });
  }
  connectedCallback() {
    this.initializeConfiguration(), this.render(), this.initUpsells();
  }
  initializeConfiguration() {
    (this.config.upsellCount = parseInt(
      this.getAttribute("data-product-count") || this.config.upsellCount
    )),
      (this.config.sectionTitle =
        this.getAttribute("data-section-title") || this.config.sectionTitle),
      (this.config.recommendationStrategy =
        this.getAttribute("data-recommendation-strategy") ||
        this.config.recommendationStrategy);
    this.product_id = this.getAttribute('data-product-id');
  }
  render() {
    this.innerHTML = `
      <div class="cart-upsell-container">
        <h2 class="cart-upsell-title">${this.config.sectionTitle}</h2>
        ${this.renderLoadingOverlay()}
        <div class="swiper cart-upsell-slider" aria-busy="true">
          <div class="swiper-wrapper">
         
          </div>
        </div>
      </div>
    `;
  }
  renderLoadingOverlay() {
    return `
      <div class="upsell-loading-overlay">
        <div class="upsell-loading-spinner"></div>
      </div>
    `;
  }
  async initUpsells() {
    try {
      const recommendedProducts = await this.fetchRecommendedProducts();
      if (!recommendedProducts || recommendedProducts.length === 0) {
        this.style.display = "none";
        return;
      }
      (this.state.newProducts = recommendedProducts),
        (this.state.isLoading = !1),
        this.updateUpsellProducts();
    } catch (error) {
      console.error("Upsell initialization failed:", error),
        (this.style.display = "none");
    }
  }
  async fetchRecommendedProducts() {
    const productId = this.product_id;
    try {
      const response = await fetch(
        `/recommendations/products.json?product_id=${productId}&limit=${this.config.upsellCount}&intent=${this.config.recommendationStrategy}`
      );
      if (!response.ok) throw new Error("Failed to fetch recommended products");
      const { products } = await response.json();
      return products;
    } catch (error) {
      return console.error("Error fetching recommendations:", error), [];
    }
  }
  updateUpsellProducts() {
    const wrapper = this.querySelector(".swiper-wrapper");
    (wrapper.innerHTML = ""),
      this.state.currentProducts.length &&
        this.state.currentProducts.forEach((product) => {
          wrapper.appendChild(this.createProductSlide(product));
        }),
      this.state.newProducts.forEach((product) => {
        wrapper.appendChild(this.createProductSlide(product));
      }),
      this.querySelector(".upsell-loading-overlay").classList.add("hidden"),
      (this.state.currentProducts = [
        ...this.state.currentProducts,
        ...this.state.newProducts,
      ]),
      (this.state.newProducts = []),
      this.addCartEventListeners(),
      this.reinitializeSwiper();
  }
  createProductSlide(product) {
    const slide = document.createElement("div");
    return (
      slide.classList.add("swiper-slide", "upsell-product"),
      (slide.dataset.productId = product.id),
      (slide.innerHTML = `
       <div class="upsell-product__media">
        <img src="${product.featured_image}" alt="${
        product.title
      }" width="150" height="150" loading="lazy">
      </div>
      <div class="custom-upsell-details">
      <a href="${product.url}" class="upsell-product__title">${
        product.title
      }</a>
      <div class="upsell-product__row">
        <p class="upsell-product__price">${Shopify.formatMoney(
          product.price
        )}</p>
        <product-form>
          <form
                  method="post"
                  action="/cart/add"
                  id="product-form-template--19051402297590__main"
                  accept-charset="UTF-8"
                  class="form"
                  enctype="multipart/form-data"
                  ovalidate="novalidate" data-type="add-to-cart-form">
            <input type="hidden" name="id" value="${
              product.variants[0].id
            }" class="product-variant-id">
            <button
                    class="add-to-cart-btn button--link button upsell-product__atc"
                    aria-haspopup="dialog"
                    type="submit"
                    data-variant-id="${product.variants[0].id}"
            >
              <span>Add</span>
              <div class="loading__spinner hidden">
  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
  </svg>
</div>
            </button>
          </form>
        </product-form>
      </div>
      </div>
    `),
      slide
    );
  }
  reinitializeSwiper() {
    this.swiper && this.swiper.destroy(),
      (this.swiper = new Swiper(this.querySelector(".swiper"), {
        slidesPerView: 1.2,
        spaceBetween: 15,
        grabCursor: !0,
        mousewheel: false,
      }));
  }
  addCartEventListeners() {
    this.querySelectorAll(".add-to-cart-btn").forEach((button) => {
      button.addEventListener("click", this.addToCart.bind(this));
    });
  }
  async addToCart(event) {
    const variantId = event.target.dataset.variantId;
    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      }),
        document.dispatchEvent(new CustomEvent("cart:updated"));
    } catch (error) {
      console.error("Add to cart failed:", error);
    }
  }
  
}
customElements.define("product-upsell", ProductUpsell);

document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelectorAll(".custom-atc-button-dir").length > 0){
    document.querySelectorAll(".custom-atc-button-dir").forEach((el) => {
      const button = el;
      button.addEventListener("click",(evt) => {
         const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
         button.classList.add('loading');
        button.querySelector('.loading__spinner').classList.remove('hidden');
        const id = button.dataset.id;
        let items = [
          {
            id:id,
            quantity:1
          }
        ];
        const formdata = {
          items:items,
          sections:cart.getSectionsToRender().map((section) => section.id),
            sections_url:window.location.pathname
        }
        fetch('/cart/add.js',{
           method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formdata)
        })
        .then((response) => response.json())
        .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: id,
                errors: response.errors || response.description,
                message: response.message,
              });
             
              return;
            } else if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
             publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: id,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            
              CartPerformance.measure("add:paint-updated-sections", () => {
                cart.renderContents(response);
              });
            
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            button.classList.remove('loading');
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            button.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      });
    });
  }
  var swiper = new Swiper(".main-hero-collection-slider .swiper-container", {
    lazy: true,
    slidesPerView: 1.2,
    spaceBetween: 20,
    loop: true,
    centeredSlides: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3.2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4.2,
        spaceBetween: 20,
      },
    },
  });
   const swiper2 = new Swiper('.custom-complementary-wrapper .swiper', {
            // Core parameters
            slidesPerView: 1.2,
            spaceBetween: 30,
            // Pagination dots
            pagination: {
                el: '.custom-complementary-wrapper .swiper-pagination',
                clickable: true,
                dynamicBullets: true,
            },
            
        });
});
document.addEventListener("product-recommendations:loaded",() => {
  setTimeout(() => {
    if(document.querySelector(".custom-recommendation-slider")){
      var swiper = new Swiper(".custom-recommendation-slider .swiper-container", {
        lazy: true,
        slidesPerView: 1.1,
        spaceBetween: 20,
        loop: false,
        centeredSlides: false,
        navigation: {
          nextEl: ".custom-swiper-buttons-controls .swiper-button-next",
          prevEl: ".custom-swiper-buttons-controls .swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3.2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      });
    }
  },1000);
});